import { PartialPartner } from "@/common/partner/types";

export default function validateIsFromUniversityOfCapetown(
  owners: PartialPartner[],
) {
  for (let i = 0; i < owners.length; i++) {
    if (owners[i].uuid === "c5b82171-94d3-40eb-befd-ade27c3d028a") {
      return true;
    }
  }
  return false;
}
